import { AccountAddress, createObjectAddress } from "@aptos-labs/ts-sdk";

export function getPredepositStateAddr(packageAddr: string) {
  return createObjectAddress(
    AccountAddress.fromString(packageAddr),
    new TextEncoder().encode("predeposit"),
  ).toString();
}
